import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import { useTranslation } from "react-i18next";
// import React from "react";
// import Image from "next/image";
import sal from "sal.js";

// import EventBreadCrumb from "./sections/EventBreadCrumb";
// import EventDetails from "./sections/EventDetails";
import CallToActionOne from "@/my_components/CallToAction/CallToActionOne";
import BlogGridMinimal from "@/my_components/Blogs/Components/BlogGridMinimal";
import Newsletter_2 from "@/my_components/Newsletters/Newsletter_2";
import EventCarouse from "@/my_components/Events/EventCarouse";
import BlogBreadCrumb from "@/my_components/Common/Blog-BreadCrumb";
import SmartTechBlogDetails from "./sections/SmartTechBlogDetails";
import BlogListItems from "@/my_components/_Blog/sections/BlogList-Items";

import BlogData from "@/data/blog/blog.json";

// CONFIGS AND ROUTE
import { ROUTE } from "@/route/app_routes.js";
import { extractNumbersFromString } from "@/helper/SpecialHelpers.js";
// import { CONFIG } from "@/app_config.js";
// import { image_url } from "../../helper/Utilities";



const SmartTechEventsDetails = () => {

  const { t } = useTranslation("blog");
  const router = useRouter();
  const postId = parseInt(extractNumbersFromString(router.query.postId));
  let blogPosts;

  blogPosts = JSON.parse(JSON.stringify(BlogData.blogList));


  const matchedBlog = blogPosts.find((post) => post.id === postId);
  const relatedPosts = blogPosts.filter((post) => post.id !== postId).slice(0, 4);

  useEffect(() => {
    if (postId && !matchedBlog) {
      router.push(ROUTE.blog);
    }
  }, [matchedBlog, router]);



  return (


    <main className="rbt-main-wrapper">



      <div className="rbt-overlay-page-wrapper bg-body-primary rbt-section-gapBottom">
        <BlogBreadCrumb matchedBlog={matchedBlog} />

        <div className="rbt-blog-details-area rbt-section-gapBottom breadcrumb-style-max-width">
          <div className="blog-content-wrapper rbt-article-content-wrapper">
            <SmartTechBlogDetails matchedBlog={matchedBlog !== undefined ? matchedBlog : ""} />
            <div className="related-post pt--60">
              <div className="section-title text-start mb--40">
                <span className="subtitle bg-primary-opacity"> {t("detail.relatedEyebrow", "Related Post")} </span>
                <h4 className="title">{t("detail.relatedTitle", "Similar Post")}</h4>
              </div>
              <BlogListItems posts={relatedPosts} />
            </div>
          </div>
        </div>
      </div>








      <CallToActionOne />









      <div className="rbt-event-area rbt-section-gap bg-gradient-3">
        <div className="container">
          <div className="row mb--55">
            <div className="section-title text-center">
              <span className="subtitle bg-white-opacity">
                  {t("events.eyebrow", "INTERESTED IN JOINING?")}
              </span>
              <h2 className="title color-white">{t("events.title", "Upcoming Events")}</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <EventCarouse />
            </div>
          </div>
        </div>
      </div>







      <div className="rbt-rbt-blog-area rbt-section-gapTop bg-gradient-8 rbt-round-bottom-shape">
        <div className="wrapper pb--50 rbt-index-upper">
            <div className="container">
                <div className="row g-5 align-items-end mb--60">
                    <div className="col-lg-6 col-md-12 col-12">
                        <div className="section-title text-start">
                        <h2 className="title color-white">{t("detail.latestNewsTitle", "Latest News")}</h2>
                        <p className="description color-white-off mt--20">
                            {t(
                              "detail.latestNewsDescription",
                              "Free, structured courses built around real projects — learn skills that translate directly into a tech career."
                            )}
                        </p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12">
                        <div className="load-more-btn text-start text-lg-end">
                            <a className="rbt-btn btn-border icon-hover radius-round color-white-off" href={ROUTE.blog}>
                                <span className="btn-text">{t("detail.seeAllArticles", "See All Articles")}</span>
                                <span className="btn-icon"><i className="feather-a~rrow-right"></i></span>
                            </a>
                        </div>
                    </div>
                </div>
                
                <BlogGridMinimal />
            </div>
        </div>
      </div>














      <div className="rbt-newsletter-area bg-color-white rbt-section-gapBottom pt--60">
          <div className="container">
              <div className="row">
                  <div className="col-lg-12">
                      <Newsletter_2 />
                  </div>
              </div>
          </div>
      </div>

















    

    </main>

  );

};


export default SmartTechEventsDetails;
